module.exports = __webpack_public_path__ + "static/media/20160615_114646.5a7dcc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20160615_114646.jpg
// module id = 449
// module chunks = 0